module.exports = __webpack_public_path__ + "static/media/app-mockup.6f2883e2.png";